export class Auth {
    constructor() {
        this.token = null;
        this.isRefreshing = false;
        this.refreshTokenPromise = null;
    }

    setToken(token) {
        this.token = token;
    }

    setAccess(access) {
        this.access = access
    }
}

export const auth = new Auth();